import { h } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import { ACTION_BLOCK_TYPES, ICONS_BY_TYPE } from '@pes-ui/utils';
const actionBlocksOrder = [
  ACTION_BLOCK_TYPES.PRODUCTS_FROM_A_TO_Z,
  ACTION_BLOCK_TYPES.PRODUCT_SELECTOR_LIST,
  ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT,
  ACTION_BLOCK_TYPES.DOWNLOAD_CENTER,
];
export class ActionBlocks {
  constructor() {
    this.actionBlocks = undefined;
    this.selectorConfig = undefined;
  }
  render() {
    const actionBlocks = actionBlocksOrder
      .map((actionBlockName) => { var _a; return (_a = this.actionBlocks) === null || _a === void 0 ? void 0 : _a[actionBlockName]; })
      .filter(Boolean);
    return (h("div", { class: "action-blocks" }, actionBlocks.map((item) => {
      if (!isEmpty(item.selectorConfig)) {
        return (h("pes-action-block-product-selector", { key: item.type, "data-autotests-id": item.type, actionBlock: item, selectorConfig: this.selectorConfig, class: "action-blocks__item" }));
      }
      return (h("pes-action-block", { key: item.type, "data-autotests-id": item.type, heading: item.label, text: item.linkText, url: item.link, icon: ICONS_BY_TYPE[item.type], class: "action-blocks__item" }));
    })));
  }
  static get is() { return "pes-action-blocks"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["action-blocks.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["action-blocks.css"]
    };
  }
  static get properties() {
    return {
      "actionBlocks": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ActionBlocksHashMap",
          "resolved": "{ [x: string]: ActionBlock; }",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "selectorConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TScProductSelectorConfig | null",
          "resolved": "{ type: \"sc\"; scConfiguratorUrlJS: string; scConfiguratorUrlCSS: string; scLanguage: string; scCountry: string; scToken: string; scProject: string; scDataset: string; scOptions: Record<string, unknown>; scFunctionalIds: string; scLabel: string; }",
          "references": {
            "TScProductSelectorConfig": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
}
